var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nb-custom',_vm._b({on:{"on-click":_vm.onClick}},'nb-custom',_vm.attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }